export default {
      id: "send-usage",
      viewBox: "0 0 267.13 196.27",
      url: __webpack_public_path__ + "img/icons.0fe16570.svg#send-usage",
      toString: function () {
        return this.url;
      }
    }